window.browser.i18n.getMessage.callsFake(text => text)
window.browser.i18n.getUILanguage.returns(navigator.language)
